export enum DistanceValue {
	LESS_THAN_5_KM = '5',
	LESS_THAN_10_KM = '10',
	LESS_THAN_15_KM = '15',
	LESS_THAN_25_KM = '25',
	LESS_THAN_50_KM = '50',
	LESS_THAN_75_KM = '75',
	LESS_THAN_100_KM = '100',
	LESS_THAN_200_KM = '200',
	ANY = 'any',
}

export enum LastUpdateValue {
	WEEK = 'week',
	MONTH = 'month',
}

export enum Availabilities {
	WEEKEND = 'weekend',
	NIGHT = 'night',
	MORNING = 'morning',
	AFTERNOON = 'afternoon',
	EVENING = 'evening',
}
